// extracted by mini-css-extract-plugin
var _1 = "PageWithWidgets-modulePageWithWidgets__h84KP";
var _2 = "PageWithWidgets-modulecontainer__SXI02";
var _3 = "PageWithWidgets-modulecontent__b10rn";
var _4 = "PageWithWidgets-modulecontentWrapper__vUxmp";
var _5 = "PageWithWidgets-modulescrollWrapper__X6x9d";
var _6 = "PageWithWidgets-modulesidePanel__zT4jV";
var _7 = "PageWithWidgets-modulewidgetsFlexible__cd7fZ";
var _8 = "PageWithWidgets-modulewidgetsHidden__LzXL7";
var _9 = "PageWithWidgets-modulewidgetsWrapper__iIysd";
var _a = "PageWithWidgets-modulewithModalsTray__OB5k_";
var _b = "PageWithWidgets-modulewithSupportButtons__ifsPO";
export { _1 as "PageWithWidgets", _2 as "container", _3 as "content", _4 as "contentWrapper", _5 as "scrollWrapper", _6 as "sidePanel", _7 as "widgetsFlexible", _8 as "widgetsHidden", _9 as "widgetsWrapper", _a as "withModalsTray", _b as "withSupportButtons" }
